import { useMemo } from 'react';

import type { IDocumentReaderUploadReference } from '@commenda/api/commenda-ai/document-reader/types';
import { useDocumentReaderUploadFiles } from '@commenda/api/commenda-ai/document-reader/useDocumentReaderUploadFiles';
import { Attachment } from '@commenda/pathfinder';

import { DataRoomAttachmentHelper } from './DataRoomAttachmentHelper';

interface DataRoomUploadPillProps {
  dataRoom: IDocumentReaderUploadReference;
}

/** The data room a chat message carries, above its bubble as ready Attachment pills (Figma 3358:1608):
 * one per file for a room of a few files, read by its id across every batch, or one pill for a larger room.
 * The room pill also shows while the names load and when they cannot be read. */
export const DataRoomUploadPill = ({ dataRoom }: DataRoomUploadPillProps) => {
  const { uploadFiles, isLoading, error } = useDocumentReaderUploadFiles(
    DataRoomAttachmentHelper.hasFilePills(dataRoom) ? dataRoom : null
  );
  const attachmentItems = useMemo(
    () =>
      DataRoomAttachmentHelper.toSentItems(
        dataRoom,
        isLoading || error ? null : uploadFiles
      ),
    [dataRoom, uploadFiles, isLoading, error]
  );

  return (
    <div className="flex flex-wrap items-center justify-end gap-sm">
      {attachmentItems.map((item) => (
        <Attachment key={item.id} item={item} />
      ))}
    </div>
  );
};
